const SortBy = {
  RANK: 4,
  CATEGORY: 6,
  LAST_UPDATED: 7,
  INTEREST_DESC: 8,
  INTEREST_ASC: 9,
};

const CollegeProgressSteps = {
  TARGET: 'Target',
  CONTACT: 'Contact',
  INTEREST: 'Interest',
  ACTIVE: 'Active',
  OFFER: 'Offer',
  COMMIT: 'Commit',
  SIGNED: 'Signed',
};

module.exports = { SortBy, CollegeProgressSteps };
